import type { HubModule } from "core-fe-lib/components-shadcn/shell/types";
import { outboxRoutes } from "./routes";
import { getOutboxLinks } from "./links";
import enUS from "./i18n/en-US";
import fr from "./i18n/fr";

export interface OutboxModuleOptions {
  requiredFeature?: string;
  adminOnly?: boolean;
  landingPath?: string;
  landingPriority?: number;
  navIcon?: string;
}

export function createOutboxModule(opts: OutboxModuleOptions = {}): HubModule {
  return {
    id: "outbox",
    name: "Outbox",
    adminOnly: opts.adminOnly ?? true,
    requiredFeature: opts.requiredFeature,
    landingPath: opts.landingPath,
    landingPriority: opts.landingPriority,
    routes: (layouts) => outboxRoutes(layouts.MainLayout),
    navLinks: (ctx) => getOutboxLinks(ctx.t, opts.navIcon ?? "outbox"),
    messages: { "en-US": enUS, fr },
  };
}
